// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v3.12.4
// source: aurora/spatial.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import {
  DGGSIndex,
  GeometryID,
  IndexableGeometry,
  LatLng,
  LatLngBBox,
  MultiPolygon,
  Payload,
  Ring,
} from "../bgsearch/bgsearch_types";
import { Struct } from "../google/protobuf/struct";
import { FilterObject } from "./filter";

export const protobufPackage = "biggeo.aurora";

export interface SpatialReq {
  dateTime: string;
  channel: string;
  multiFilters: FilterObject[];
  withTable: boolean;
  requestId: string;
  viewport?: LatLngBBox | undefined;
  multipolygon?: MultiPolygon | undefined;
}

export interface SpatialDataSuccess {
  records: SpatialDataSuccess_Record[];
  aggregates: SpatialDataSuccess_Aggregate[];
  levelSets: SpatialDataSuccess_LevelSet[];
}

export interface SpatialDataSuccess_Record {
  id: GeometryID | undefined;
  geometry?: IndexableGeometry | undefined;
  payload?: Payload | undefined;
}

export interface SpatialDataSuccess_Aggregate {
  cellIndex: DGGSIndex | undefined;
  cellVertices: Ring | undefined;
  pointCount: Long;
  nonPointCount: Long;
  meanPoint: LatLng | undefined;
}

export interface SpatialDataSuccess_LevelSet {
  percentile: number;
  rings: Ring[];
}

export interface SpatialDataRsp {
  dateTime: string;
  databaseId: string;
  uniqueId: string;
  searchResult: SpatialDataSuccess | undefined;
  timeMs: Long;
  extraData?: string | undefined;
  channel: string;
  requestId: string;
  collectionExist: boolean;
}

export interface TableDataRsp {
  databaseId: string;
  uniqueId: string;
  timeMs: Long;
  channel: string;
  requestId: string;
  count: number;
  rows: { [key: string]: any }[];
}

function createBaseSpatialReq(): SpatialReq {
  return {
    dateTime: "",
    channel: "",
    multiFilters: [],
    withTable: false,
    requestId: "",
    viewport: undefined,
    multipolygon: undefined,
  };
}

export const SpatialReq: MessageFns<SpatialReq> = {
  encode(message: SpatialReq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dateTime !== "") {
      writer.uint32(10).string(message.dateTime);
    }
    if (message.channel !== "") {
      writer.uint32(18).string(message.channel);
    }
    for (const v of message.multiFilters) {
      FilterObject.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.withTable !== false) {
      writer.uint32(32).bool(message.withTable);
    }
    if (message.requestId !== "") {
      writer.uint32(42).string(message.requestId);
    }
    if (message.viewport !== undefined) {
      LatLngBBox.encode(message.viewport, writer.uint32(50).fork()).join();
    }
    if (message.multipolygon !== undefined) {
      MultiPolygon.encode(message.multipolygon, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpatialReq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpatialReq();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dateTime = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.channel = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.multiFilters.push(FilterObject.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.withTable = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.requestId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.viewport = LatLngBBox.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.multipolygon = MultiPolygon.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpatialReq {
    return {
      dateTime: isSet(object.dateTime) ? globalThis.String(object.dateTime) : "",
      channel: isSet(object.channel) ? globalThis.String(object.channel) : "",
      multiFilters: globalThis.Array.isArray(object?.multiFilters)
        ? object.multiFilters.map((e: any) => FilterObject.fromJSON(e))
        : [],
      withTable: isSet(object.withTable) ? globalThis.Boolean(object.withTable) : false,
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
      viewport: isSet(object.viewport) ? LatLngBBox.fromJSON(object.viewport) : undefined,
      multipolygon: isSet(object.multipolygon) ? MultiPolygon.fromJSON(object.multipolygon) : undefined,
    };
  },

  toJSON(message: SpatialReq): unknown {
    const obj: any = {};
    if (message.dateTime !== "") {
      obj.dateTime = message.dateTime;
    }
    if (message.channel !== "") {
      obj.channel = message.channel;
    }
    if (message.multiFilters?.length) {
      obj.multiFilters = message.multiFilters.map((e) => FilterObject.toJSON(e));
    }
    if (message.withTable !== false) {
      obj.withTable = message.withTable;
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.viewport !== undefined) {
      obj.viewport = LatLngBBox.toJSON(message.viewport);
    }
    if (message.multipolygon !== undefined) {
      obj.multipolygon = MultiPolygon.toJSON(message.multipolygon);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpatialReq>, I>>(base?: I): SpatialReq {
    return SpatialReq.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpatialReq>, I>>(object: I): SpatialReq {
    const message = createBaseSpatialReq();
    message.dateTime = object.dateTime ?? "";
    message.channel = object.channel ?? "";
    message.multiFilters = object.multiFilters?.map((e) => FilterObject.fromPartial(e)) || [];
    message.withTable = object.withTable ?? false;
    message.requestId = object.requestId ?? "";
    message.viewport = (object.viewport !== undefined && object.viewport !== null)
      ? LatLngBBox.fromPartial(object.viewport)
      : undefined;
    message.multipolygon = (object.multipolygon !== undefined && object.multipolygon !== null)
      ? MultiPolygon.fromPartial(object.multipolygon)
      : undefined;
    return message;
  },
};

function createBaseSpatialDataSuccess(): SpatialDataSuccess {
  return { records: [], aggregates: [], levelSets: [] };
}

export const SpatialDataSuccess: MessageFns<SpatialDataSuccess> = {
  encode(message: SpatialDataSuccess, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.records) {
      SpatialDataSuccess_Record.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.aggregates) {
      SpatialDataSuccess_Aggregate.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.levelSets) {
      SpatialDataSuccess_LevelSet.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpatialDataSuccess {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpatialDataSuccess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.records.push(SpatialDataSuccess_Record.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.aggregates.push(SpatialDataSuccess_Aggregate.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.levelSets.push(SpatialDataSuccess_LevelSet.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpatialDataSuccess {
    return {
      records: globalThis.Array.isArray(object?.records)
        ? object.records.map((e: any) => SpatialDataSuccess_Record.fromJSON(e))
        : [],
      aggregates: globalThis.Array.isArray(object?.aggregates)
        ? object.aggregates.map((e: any) => SpatialDataSuccess_Aggregate.fromJSON(e))
        : [],
      levelSets: globalThis.Array.isArray(object?.levelSets)
        ? object.levelSets.map((e: any) => SpatialDataSuccess_LevelSet.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SpatialDataSuccess): unknown {
    const obj: any = {};
    if (message.records?.length) {
      obj.records = message.records.map((e) => SpatialDataSuccess_Record.toJSON(e));
    }
    if (message.aggregates?.length) {
      obj.aggregates = message.aggregates.map((e) => SpatialDataSuccess_Aggregate.toJSON(e));
    }
    if (message.levelSets?.length) {
      obj.levelSets = message.levelSets.map((e) => SpatialDataSuccess_LevelSet.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpatialDataSuccess>, I>>(base?: I): SpatialDataSuccess {
    return SpatialDataSuccess.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpatialDataSuccess>, I>>(object: I): SpatialDataSuccess {
    const message = createBaseSpatialDataSuccess();
    message.records = object.records?.map((e) => SpatialDataSuccess_Record.fromPartial(e)) || [];
    message.aggregates = object.aggregates?.map((e) => SpatialDataSuccess_Aggregate.fromPartial(e)) || [];
    message.levelSets = object.levelSets?.map((e) => SpatialDataSuccess_LevelSet.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSpatialDataSuccess_Record(): SpatialDataSuccess_Record {
  return { id: undefined, geometry: undefined, payload: undefined };
}

export const SpatialDataSuccess_Record: MessageFns<SpatialDataSuccess_Record> = {
  encode(message: SpatialDataSuccess_Record, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      GeometryID.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.geometry !== undefined) {
      IndexableGeometry.encode(message.geometry, writer.uint32(18).fork()).join();
    }
    if (message.payload !== undefined) {
      Payload.encode(message.payload, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpatialDataSuccess_Record {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpatialDataSuccess_Record();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = GeometryID.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.geometry = IndexableGeometry.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.payload = Payload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpatialDataSuccess_Record {
    return {
      id: isSet(object.id) ? GeometryID.fromJSON(object.id) : undefined,
      geometry: isSet(object.geometry) ? IndexableGeometry.fromJSON(object.geometry) : undefined,
      payload: isSet(object.payload) ? Payload.fromJSON(object.payload) : undefined,
    };
  },

  toJSON(message: SpatialDataSuccess_Record): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = GeometryID.toJSON(message.id);
    }
    if (message.geometry !== undefined) {
      obj.geometry = IndexableGeometry.toJSON(message.geometry);
    }
    if (message.payload !== undefined) {
      obj.payload = Payload.toJSON(message.payload);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpatialDataSuccess_Record>, I>>(base?: I): SpatialDataSuccess_Record {
    return SpatialDataSuccess_Record.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpatialDataSuccess_Record>, I>>(object: I): SpatialDataSuccess_Record {
    const message = createBaseSpatialDataSuccess_Record();
    message.id = (object.id !== undefined && object.id !== null) ? GeometryID.fromPartial(object.id) : undefined;
    message.geometry = (object.geometry !== undefined && object.geometry !== null)
      ? IndexableGeometry.fromPartial(object.geometry)
      : undefined;
    message.payload = (object.payload !== undefined && object.payload !== null)
      ? Payload.fromPartial(object.payload)
      : undefined;
    return message;
  },
};

function createBaseSpatialDataSuccess_Aggregate(): SpatialDataSuccess_Aggregate {
  return {
    cellIndex: undefined,
    cellVertices: undefined,
    pointCount: Long.UZERO,
    nonPointCount: Long.UZERO,
    meanPoint: undefined,
  };
}

export const SpatialDataSuccess_Aggregate: MessageFns<SpatialDataSuccess_Aggregate> = {
  encode(message: SpatialDataSuccess_Aggregate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cellIndex !== undefined) {
      DGGSIndex.encode(message.cellIndex, writer.uint32(10).fork()).join();
    }
    if (message.cellVertices !== undefined) {
      Ring.encode(message.cellVertices, writer.uint32(18).fork()).join();
    }
    if (!message.pointCount.equals(Long.UZERO)) {
      writer.uint32(24).uint64(message.pointCount.toString());
    }
    if (!message.nonPointCount.equals(Long.UZERO)) {
      writer.uint32(32).uint64(message.nonPointCount.toString());
    }
    if (message.meanPoint !== undefined) {
      LatLng.encode(message.meanPoint, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpatialDataSuccess_Aggregate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpatialDataSuccess_Aggregate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cellIndex = DGGSIndex.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cellVertices = Ring.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pointCount = Long.fromString(reader.uint64().toString(), true);
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.nonPointCount = Long.fromString(reader.uint64().toString(), true);
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.meanPoint = LatLng.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpatialDataSuccess_Aggregate {
    return {
      cellIndex: isSet(object.cellIndex) ? DGGSIndex.fromJSON(object.cellIndex) : undefined,
      cellVertices: isSet(object.cellVertices) ? Ring.fromJSON(object.cellVertices) : undefined,
      pointCount: isSet(object.pointCount) ? Long.fromValue(object.pointCount) : Long.UZERO,
      nonPointCount: isSet(object.nonPointCount) ? Long.fromValue(object.nonPointCount) : Long.UZERO,
      meanPoint: isSet(object.meanPoint) ? LatLng.fromJSON(object.meanPoint) : undefined,
    };
  },

  toJSON(message: SpatialDataSuccess_Aggregate): unknown {
    const obj: any = {};
    if (message.cellIndex !== undefined) {
      obj.cellIndex = DGGSIndex.toJSON(message.cellIndex);
    }
    if (message.cellVertices !== undefined) {
      obj.cellVertices = Ring.toJSON(message.cellVertices);
    }
    if (!message.pointCount.equals(Long.UZERO)) {
      obj.pointCount = (message.pointCount || Long.UZERO).toString();
    }
    if (!message.nonPointCount.equals(Long.UZERO)) {
      obj.nonPointCount = (message.nonPointCount || Long.UZERO).toString();
    }
    if (message.meanPoint !== undefined) {
      obj.meanPoint = LatLng.toJSON(message.meanPoint);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpatialDataSuccess_Aggregate>, I>>(base?: I): SpatialDataSuccess_Aggregate {
    return SpatialDataSuccess_Aggregate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpatialDataSuccess_Aggregate>, I>>(object: I): SpatialDataSuccess_Aggregate {
    const message = createBaseSpatialDataSuccess_Aggregate();
    message.cellIndex = (object.cellIndex !== undefined && object.cellIndex !== null)
      ? DGGSIndex.fromPartial(object.cellIndex)
      : undefined;
    message.cellVertices = (object.cellVertices !== undefined && object.cellVertices !== null)
      ? Ring.fromPartial(object.cellVertices)
      : undefined;
    message.pointCount = (object.pointCount !== undefined && object.pointCount !== null)
      ? Long.fromValue(object.pointCount)
      : Long.UZERO;
    message.nonPointCount = (object.nonPointCount !== undefined && object.nonPointCount !== null)
      ? Long.fromValue(object.nonPointCount)
      : Long.UZERO;
    message.meanPoint = (object.meanPoint !== undefined && object.meanPoint !== null)
      ? LatLng.fromPartial(object.meanPoint)
      : undefined;
    return message;
  },
};

function createBaseSpatialDataSuccess_LevelSet(): SpatialDataSuccess_LevelSet {
  return { percentile: 0, rings: [] };
}

export const SpatialDataSuccess_LevelSet: MessageFns<SpatialDataSuccess_LevelSet> = {
  encode(message: SpatialDataSuccess_LevelSet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.percentile !== 0) {
      writer.uint32(17).double(message.percentile);
    }
    for (const v of message.rings) {
      Ring.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpatialDataSuccess_LevelSet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpatialDataSuccess_LevelSet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.percentile = reader.double();
          continue;
        }
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rings.push(Ring.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpatialDataSuccess_LevelSet {
    return {
      percentile: isSet(object.percentile) ? globalThis.Number(object.percentile) : 0,
      rings: globalThis.Array.isArray(object?.rings) ? object.rings.map((e: any) => Ring.fromJSON(e)) : [],
    };
  },

  toJSON(message: SpatialDataSuccess_LevelSet): unknown {
    const obj: any = {};
    if (message.percentile !== 0) {
      obj.percentile = message.percentile;
    }
    if (message.rings?.length) {
      obj.rings = message.rings.map((e) => Ring.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpatialDataSuccess_LevelSet>, I>>(base?: I): SpatialDataSuccess_LevelSet {
    return SpatialDataSuccess_LevelSet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpatialDataSuccess_LevelSet>, I>>(object: I): SpatialDataSuccess_LevelSet {
    const message = createBaseSpatialDataSuccess_LevelSet();
    message.percentile = object.percentile ?? 0;
    message.rings = object.rings?.map((e) => Ring.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSpatialDataRsp(): SpatialDataRsp {
  return {
    dateTime: "",
    databaseId: "",
    uniqueId: "",
    searchResult: undefined,
    timeMs: Long.UZERO,
    extraData: undefined,
    channel: "",
    requestId: "",
    collectionExist: false,
  };
}

export const SpatialDataRsp: MessageFns<SpatialDataRsp> = {
  encode(message: SpatialDataRsp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dateTime !== "") {
      writer.uint32(10).string(message.dateTime);
    }
    if (message.databaseId !== "") {
      writer.uint32(18).string(message.databaseId);
    }
    if (message.uniqueId !== "") {
      writer.uint32(26).string(message.uniqueId);
    }
    if (message.searchResult !== undefined) {
      SpatialDataSuccess.encode(message.searchResult, writer.uint32(34).fork()).join();
    }
    if (!message.timeMs.equals(Long.UZERO)) {
      writer.uint32(40).uint64(message.timeMs.toString());
    }
    if (message.extraData !== undefined) {
      writer.uint32(50).string(message.extraData);
    }
    if (message.channel !== "") {
      writer.uint32(58).string(message.channel);
    }
    if (message.requestId !== "") {
      writer.uint32(66).string(message.requestId);
    }
    if (message.collectionExist !== false) {
      writer.uint32(72).bool(message.collectionExist);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpatialDataRsp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpatialDataRsp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dateTime = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.databaseId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.uniqueId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.searchResult = SpatialDataSuccess.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.timeMs = Long.fromString(reader.uint64().toString(), true);
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.extraData = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.channel = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.requestId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.collectionExist = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpatialDataRsp {
    return {
      dateTime: isSet(object.dateTime) ? globalThis.String(object.dateTime) : "",
      databaseId: isSet(object.databaseId) ? globalThis.String(object.databaseId) : "",
      uniqueId: isSet(object.uniqueId) ? globalThis.String(object.uniqueId) : "",
      searchResult: isSet(object.searchResult) ? SpatialDataSuccess.fromJSON(object.searchResult) : undefined,
      timeMs: isSet(object.timeMs) ? Long.fromValue(object.timeMs) : Long.UZERO,
      extraData: isSet(object.extraData) ? globalThis.String(object.extraData) : undefined,
      channel: isSet(object.channel) ? globalThis.String(object.channel) : "",
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
      collectionExist: isSet(object.collectionExist) ? globalThis.Boolean(object.collectionExist) : false,
    };
  },

  toJSON(message: SpatialDataRsp): unknown {
    const obj: any = {};
    if (message.dateTime !== "") {
      obj.dateTime = message.dateTime;
    }
    if (message.databaseId !== "") {
      obj.databaseId = message.databaseId;
    }
    if (message.uniqueId !== "") {
      obj.uniqueId = message.uniqueId;
    }
    if (message.searchResult !== undefined) {
      obj.searchResult = SpatialDataSuccess.toJSON(message.searchResult);
    }
    if (!message.timeMs.equals(Long.UZERO)) {
      obj.timeMs = (message.timeMs || Long.UZERO).toString();
    }
    if (message.extraData !== undefined) {
      obj.extraData = message.extraData;
    }
    if (message.channel !== "") {
      obj.channel = message.channel;
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.collectionExist !== false) {
      obj.collectionExist = message.collectionExist;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpatialDataRsp>, I>>(base?: I): SpatialDataRsp {
    return SpatialDataRsp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpatialDataRsp>, I>>(object: I): SpatialDataRsp {
    const message = createBaseSpatialDataRsp();
    message.dateTime = object.dateTime ?? "";
    message.databaseId = object.databaseId ?? "";
    message.uniqueId = object.uniqueId ?? "";
    message.searchResult = (object.searchResult !== undefined && object.searchResult !== null)
      ? SpatialDataSuccess.fromPartial(object.searchResult)
      : undefined;
    message.timeMs = (object.timeMs !== undefined && object.timeMs !== null)
      ? Long.fromValue(object.timeMs)
      : Long.UZERO;
    message.extraData = object.extraData ?? undefined;
    message.channel = object.channel ?? "";
    message.requestId = object.requestId ?? "";
    message.collectionExist = object.collectionExist ?? false;
    return message;
  },
};

function createBaseTableDataRsp(): TableDataRsp {
  return { databaseId: "", uniqueId: "", timeMs: Long.UZERO, channel: "", requestId: "", count: 0, rows: [] };
}

export const TableDataRsp: MessageFns<TableDataRsp> = {
  encode(message: TableDataRsp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.databaseId !== "") {
      writer.uint32(10).string(message.databaseId);
    }
    if (message.uniqueId !== "") {
      writer.uint32(18).string(message.uniqueId);
    }
    if (!message.timeMs.equals(Long.UZERO)) {
      writer.uint32(24).uint64(message.timeMs.toString());
    }
    if (message.channel !== "") {
      writer.uint32(34).string(message.channel);
    }
    if (message.requestId !== "") {
      writer.uint32(42).string(message.requestId);
    }
    if (message.count !== 0) {
      writer.uint32(48).int32(message.count);
    }
    for (const v of message.rows) {
      Struct.encode(Struct.wrap(v!), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TableDataRsp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTableDataRsp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.databaseId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.uniqueId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.timeMs = Long.fromString(reader.uint64().toString(), true);
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.channel = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.requestId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.count = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.rows.push(Struct.unwrap(Struct.decode(reader, reader.uint32())));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TableDataRsp {
    return {
      databaseId: isSet(object.databaseId) ? globalThis.String(object.databaseId) : "",
      uniqueId: isSet(object.uniqueId) ? globalThis.String(object.uniqueId) : "",
      timeMs: isSet(object.timeMs) ? Long.fromValue(object.timeMs) : Long.UZERO,
      channel: isSet(object.channel) ? globalThis.String(object.channel) : "",
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
      rows: globalThis.Array.isArray(object?.rows) ? [...object.rows] : [],
    };
  },

  toJSON(message: TableDataRsp): unknown {
    const obj: any = {};
    if (message.databaseId !== "") {
      obj.databaseId = message.databaseId;
    }
    if (message.uniqueId !== "") {
      obj.uniqueId = message.uniqueId;
    }
    if (!message.timeMs.equals(Long.UZERO)) {
      obj.timeMs = (message.timeMs || Long.UZERO).toString();
    }
    if (message.channel !== "") {
      obj.channel = message.channel;
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    if (message.rows?.length) {
      obj.rows = message.rows;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TableDataRsp>, I>>(base?: I): TableDataRsp {
    return TableDataRsp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TableDataRsp>, I>>(object: I): TableDataRsp {
    const message = createBaseTableDataRsp();
    message.databaseId = object.databaseId ?? "";
    message.uniqueId = object.uniqueId ?? "";
    message.timeMs = (object.timeMs !== undefined && object.timeMs !== null)
      ? Long.fromValue(object.timeMs)
      : Long.UZERO;
    message.channel = object.channel ?? "";
    message.requestId = object.requestId ?? "";
    message.count = object.count ?? 0;
    message.rows = object.rows?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
